import { parse } from "valibot";
const valibotSearchValidator = (options) => {
  var _a, _b;
  return {
    types: {
      input: (_a = options._types) == null ? void 0 : _a.input,
      output: (_b = options._types) == null ? void 0 : _b.output
    },
    parse: (input) => parse(options, input)
  };
};
export {
  valibotSearchValidator
};
//# sourceMappingURL=index.js.map
